export default {
  SAVE_LOGIN_INFO(state,loginInfo){
    state.loginInfo=loginInfo
  },
  SAVE_PAGE_LOAD(state,pageLoad){
    state.pageLoad=pageLoad
  },
  SAVE_USER(state,user){
    state.user=user
  }
}



// WEBPACK FOOTER //
// ./src/store/axj-web/mutaions.js